@if (inputStringValue && blurCalled) {
  <dl class="p-2">
    <dt>{{ dtValue }}</dt>
    <dd class="d-flex align-items-center">
      {{ inputStringValue }}
      <span class="ms-3 edit-button" (click)="editField()"></span>
    </dd>
  </dl>
}
@if (!blurCalled || !inputStringValue) {
  <div class="input-group">
    <div class="form-floating">
      <input
        class="form-control"
        autocomplete="off"
        [id]="inputId"
        [type]="inputFieldType"
        [(ngModel)]="inputStringValue"
        [placeholder]="dtValue"
        [maxlength]="maxLength"
        (blur)="
          inputStringValue && inputStringValue.trim()
            ? onBlurEventTrigger()
            : blurEmit.emit(inputStringValue)
        "
      />
      <label>{{ dtValue }}</label>
    </div>
    @if (inputStringValue) {
      <span class="input-group-text">
        <i class="fa-solid fa-check text-success"></i>
      </span>
    }
    @if (inputStringValue) {
      <span class="input-group-text" (click)="editField(true)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    }
  </div>
}
